<template>
  <div :class="{ 'mobile-bg': isMobile }">
    <SEOHead :title="seoData.title" :description="seoData.description" :keywords="seoData.keywords"
      :structured-data="seoData.structuredData" />
    <ProductPricePC v-if="!isMobile" />
    <ProductPriceMobile v-else />
  </div>
</template>

<script>
import ProductPricePC from './ProductPricePC.vue'
import ProductPriceMobile from './ProductPriceMobile.vue'
import SEOHead from '@/components/SEOHead.vue'
import responsive from '@/utils/responsive'

export default {
  components: { ProductPricePC, ProductPriceMobile, SEOHead },
  data() {
    return {
      responsive,
      seoData: {
        title: '七鼠智服价格方案 - AI智能客服系统报价 | 智寰科技',
        description: '智寰科技七鼠智服AI智能客服系统价格方案，提供多种套餐选择，满足不同规模电商企业需求。专业的AI客服解决方案，助力企业降本增效。',
        keywords: '七鼠智服价格,AI智能客服价格,智能客服系统报价,电商客服价格,智寰科技价格,客服系统费用',
        structuredData: {
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "七鼠智服价格方案",
          "description": "智寰科技七鼠智服AI智能客服系统价格方案，提供多种套餐选择",
          "url": "https://zhihuanai.com/price",
          "mainEntity": {
            "@type": "Product",
            "name": "七鼠智服",
            "brand": {
              "@type": "Brand",
              "name": "智寰科技"
            },
            "offers": {
              "@type": "AggregateOffer",
              "description": "AI智能客服系统多种价格方案",
              "seller": {
                "@type": "Organization",
                "name": "智寰科技"
              }
            }
          }
        }
      }
    }
  },
  computed: {
    isMobile() {
      return this.responsive.isMobile
    }
  }
}
</script>

<style scoped>
.page-content {
  text-align: center;
}

/* 移动端背景色 */
.mobile-bg {
  background-color: #F5F7FB;
}
</style>